import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import TermsAndConditions from "../other/TermsAndConditions";
import { useNavigate } from "react-router";
import { useAcceptTermsMutation } from "generated/generated-models";
import { Button, Tooltip } from "@mui/material";
const AcceptTerms = () => {
    const navigate = useNavigate();
    const [acceptedTerms, setAcceptedTerms] = useState(undefined);
    const [readTerms, setReadTerms] = useState(false);
    const [acceptTerms] = useAcceptTermsMutation();
    const handleUserAcceptsTerms = async () => {
        await acceptTerms();
        setAcceptedTerms(true);
    };
    const handleScroll = (e) => {
        // Get how close the user is to scrolling to the bottom of the page
        const difference = e.currentTarget.scrollHeight -
            e.currentTarget.scrollTop -
            e.currentTarget.clientHeight;
        // Use an epsilon cause floating point numbers are sad
        const bottom = Math.abs(difference) < 10;
        if (bottom) {
            setReadTerms(true);
        }
    };
    if (acceptedTerms === false) {
        navigate("/security/logout");
    }
    if (acceptedTerms === true) {
        navigate("/");
    }
    return (_jsx("section", { className: "content-wrapper flex-fill", children: _jsxs("div", { className: "container sub-wrap firsttimelogin-page", children: [_jsx("div", { className: "firsttimelogin-tc-container", onScroll: handleScroll, children: _jsx("div", { className: "firsttimelogin-tc-inner", children: _jsx(TermsAndConditions, {}) }) }), _jsxs("div", { className: "firsttimelogin-tc-button-container", children: [_jsx(Button, { variant: "outlined", sx: { p: 1.5, mt: 1 }, onClick: () => setAcceptedTerms(false), id: "cancel", children: "Cancel" }), _jsx(Tooltip, { title: "Please read to the end of the Terms and Conditions", disableHoverListener: readTerms, children: _jsx("div", { className: "d-inline-block float-right", children: _jsx(Button, { variant: "contained", sx: { p: 1.5, mt: 1 }, style: {
                                        pointerEvents: readTerms ? "auto" : "none",
                                    }, type: "submit", disabled: !readTerms, onClick: handleUserAcceptsTerms, id: "acceptTermsAndConditionsButton", children: "Accept Terms" }) }) })] })] }) }));
};
export default AcceptTerms;
